import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react';
import type { SortDir } from '../../api/products';

/**
 * A column header that sorts on click (BOT-505).
 *
 * Presentational only: the page owns the sort state and the server does the
 * sorting — `DataTable` and TanStack's sorted row model stay out of it
 * (decision tablesort: server-side or not offered).
 */
export function SortableHeader({ label, dir, onClick }: {
  label: string;
  dir: SortDir | null;
  onClick: () => void;
}) {
  const Icon = dir === 'desc' ? ArrowDown : dir === 'asc' ? ArrowUp : ArrowUpDown;
  return (
    <button
      type="button"
      aria-label={`Sort by ${label}`}
      data-sort={dir ?? 'none'}
      onClick={onClick}
      className="inline-flex items-center gap-1 whitespace-nowrap font-medium hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
    >
      {label}
      <Icon className={dir ? 'h-3 w-3 text-foreground' : 'h-3 w-3 text-zinc-300'} aria-hidden />
    </button>
  );
}
